export enum EDocumentType {
  occupational = 1,
  childcareAssistance = 2,
}
